import React from 'react';
import PropTypes from 'prop-types';

const SimpleListItem = ({ children }) => (
  <li className="simplelist__item">{children}</li>
);

SimpleListItem.propTypes = {
  children: PropTypes.node.isRequired
};

const SimpleListLink = ({ children, ...rest }) => (
  <a className="simplelist__link" {...rest}>
    {children}
  </a>
);

SimpleListLink.propTypes = {
  children: PropTypes.node.isRequired
};

const SimpleList = ({ children, plus }) => (
  <ul
    className={`simplelist${plus ? ' simplelist--icons simplelist--plus' : ''}`}
  >
    {children}
  </ul>
);

SimpleList.Item = SimpleListItem;
SimpleList.Link = SimpleListLink;

SimpleList.propTypes = {
  children: PropTypes.node.isRequired,
  plus: PropTypes.bool
};

SimpleList.defaultProps = {
  plus: false
};

export default SimpleList;



// WEBPACK FOOTER //
// ./src/components/Common/SimpleList/SimpleList.js